var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgITwitterDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3733 0C12.676 0 0.792969 11.883 0.792969 26.5804C0.792969 41.2777 12.676 53.1607 27.3733 53.1607C42.0707 53.1607 53.9537 41.2777 53.9537 26.5804C53.9537 11.883 42.0707 0 27.3733 0ZM39.2563 20.5138C39.2563 20.764 39.2563 21.0141 39.2563 21.3268C39.2563 29.3947 33.1272 38.7135 21.8696 38.7135C18.5549 38.7135 15.3027 37.7754 12.4883 35.9617C12.9887 36.0242 13.489 36.0242 13.9268 36.0242C16.6786 36.0242 19.368 35.0861 21.4944 33.3974C18.8676 33.3349 16.6161 31.6463 15.8031 29.1446C16.7412 29.3322 17.6793 29.2697 18.5549 29.0195C15.678 28.4566 13.6766 25.9549 13.6766 23.0155V22.9529C14.5522 23.4533 15.4903 23.7034 16.4285 23.7034C13.7392 21.8897 12.9261 18.3248 14.5522 15.573C17.6793 19.388 22.2449 21.7021 27.1232 21.9522C26.9981 21.5145 26.9981 21.0141 26.9355 20.5763C26.9355 18.8877 27.6235 17.2616 28.8744 16.1358C31.3135 13.8218 35.1911 13.9469 37.5051 16.386C38.8811 16.1358 40.1945 15.6355 41.3828 14.885C40.945 16.3235 40.0068 17.5118 38.6934 18.2623C39.8817 18.1372 41.07 17.7619 42.1958 17.3241C41.4453 18.575 40.4446 19.6382 39.2563 20.5138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgITwitterDesktop);
export default __webpack_public_path__ + "static/media/i_twitter_desktop.80fa2e75a75070edbe694f7d87853c9a.svg";
export { ForwardRef as ReactComponent };